import { isNil } from 'lodash';

import fromAnyToString from 'utils/converters/fromAnyToString';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';

const L = logger('currencyFixed');

const currencyFixed = (options) => {
  const { value, fraction } = asObject(options);

  const string = Number.isNaN(value) ? '' : fromAnyToString(value);

  if (string === '') {
    return string;
  }

  if (isNil(fraction)) {
    return string;
  }

  let parsed = string;
  try {
    parsed = Number.parseFloat(string);
  } catch (e) {
    L.warn('()', 'Number.parseFloat() error:', e);
    return string;
  }

  try {
    return parsed.toFixed(fraction);
  } catch (e) {
    L.warn('()', 'parsed.toFixed() error:', e);
    return fromAnyToString(parsed);
  }
};

// noinspection JSUnusedGlobalSymbols
export default currencyFixed;
